import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=8726a09a&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=ts&"
export * from "./Features.vue?vue&type=script&lang=ts&"
import style0 from "./Features.vue?vue&type=style&index=0&id=8726a09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8726a09a",
  null
  
)

export default component.exports